export enum ActionErrorCode {
  InvalidClient = 7210,
  Unexpected = 7299,
}

export enum ActionType {
  None = 0,
  ActionGroup = 20,
  EventGroup = 25,
}
